import type { ComponentProps } from "react";
import ContentIndex from "@/components/content/ContentIndex";
import { contentIndexProps } from "@/utils/contentProps";

export default function BlogIndex(
  props: Pick<ComponentProps<typeof ContentIndex>, "pages">,
) {
  return (
    <ContentIndex
      section="blog"
      title="Jammable Blog: AI Voice and AI Cover Guides"
      metaDescription="Step-by-step guides to AI covers, training your own AI voice, RVC models and text-to-speech, from the team behind Jammable."
      h1="Guides"
      intro="How to make AI covers, train a voice of your own and get the most out of 60,000+ community voices."
      pages={props.pages}
    />
  );
}

export const getStaticProps = contentIndexProps("blog");
